import { ReactNode } from 'react';
import { ModalMultiUse, Button, Paragraph } from '@sentara-health/optimahealth_web';

interface LongButtonModalProps {
  isOpen: boolean;
  header: string;
  body: ReactNode;
  buttonLabel: string;
  buttonTestId?: string;
  onConfirm: () => void;
  onClose?: () => void;
  buttonVariant?: 'primary_btn' | 'secondary_btn';
  secondaryButtonLabel?: string;
  secondaryButtonTestId?: string;
  onSecondaryClick?: () => void;
  secondaryButtonVariant?: 'primary_btn' | 'secondary_btn';
  footerNote?: ReactNode;
  isMobile?: boolean;
}

const LongButtonModal = ({
  isOpen,
  header,
  body,
  buttonLabel,
  buttonTestId = 'confirmButton',
  onConfirm,
  onClose,
  buttonVariant = 'primary_btn',
  secondaryButtonLabel,
  secondaryButtonTestId = 'secondaryButton',
  onSecondaryClick,
  secondaryButtonVariant = 'secondary_btn',
  footerNote,
  isMobile = false,
}: LongButtonModalProps) => {
  const hasSecondaryButton = Boolean(secondaryButtonLabel);

  return (
    <ModalMultiUse
      btnClose={false}
      header={header}
      body={
        <div>
          {typeof body === 'string' ? (
            <Paragraph text={body} variant="regular" className="mb-0" />
          ) : (
            body
          )}
        </div>
      }
      footer={
        <>
          <div
            className={
              hasSecondaryButton
                ? 'col-md-6 col-12 mb-md-0 mb-3 ps-sm-0 pe-sm-2 px-0'
                : 'mb-md-0 mb-3 ps-sm-0 px-0'
            }
          >
            <Button
              dataTestId={buttonTestId}
              variant={buttonVariant}
              className="btn-md-height w-100"
              type="button"
              onClick={onConfirm}
            >
              {buttonLabel}
            </Button>
          </div>
          {hasSecondaryButton && (
            <div className="col-md-6 col-12 ps-sm-2 pe-sm-0 px-0">
              <Button
                dataTestId={secondaryButtonTestId}
                variant={secondaryButtonVariant}
                className="btn-md-height w-100"
                type="button"
                onClick={onSecondaryClick || onClose}
              >
                {secondaryButtonLabel}
              </Button>
            </div>
          )}
          {footerNote && <div className="col-12 mt-3">{footerNote}</div>}
        </>
      }
      variant="defaultNoPyBody"
      isMobile={isMobile}
      isOpen={isOpen}
    />
  );
};

export default LongButtonModal;
